module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/guestbooks/bravenet_guestbooks_responsive_design.png";